import script from "./TogetherView.vue?vue&type=script&setup=true&lang=js"
export * from "./TogetherView.vue?vue&type=script&setup=true&lang=js"

import "./TogetherView.vue?vue&type=style&index=0&id=5061f706&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5061f706"]])

export default __exports__